import { useEffect, useState } from 'react'
import Footer from '../../../Components/Footer/Index'
import { useLocation, useParams } from 'react-router-dom'
import axios from 'axios'
import useMediaQuery from '../../../hooks/useMediaQuery'
import { RelatedArts } from './components/RelatedArts'
import { Documents } from './components/Documents'
import { ArtInfos } from './components/ArtInfos'
import { ToastContact } from './components/ToastContact'
import { auth, db } from '../../../firebase'
import { ToastEmail } from './components/ToastEmail'
import { StatsProfile } from './components/Stats'
import { QRCodeBlock } from './components/QRCodeBlock'
import { BlockchainHash } from './components/BlockchainHash'
import { CircleLight } from '../../../Components/Screen/circleLight'
import { child, get, ref } from 'firebase/database'

export default function FarmsViewPage() {
  const [isToastOpen, setIsToastOpen] = useState(false)
  const mQuery = useMediaQuery('(min-width: 768px)')
  let isEmailSended = false

  const history = useLocation()
  const { artId } = useParams()

  const [art, setArt] = useState(history?.state?.art || null)
  const [arts, setArts] = useState(history?.state?.arts || null)
  const [loading, setLoading] = useState(!history?.state?.art)

  useEffect(() => {
    window.scrollTo(0, 0)
  }, [art])

  useEffect(() => {
    if (history?.state?.art) {
      setArt(history.state.art)
      if (history.state.arts) setArts(history.state.arts)
      setLoading(false)
      return
    }

    async function fetchByCarId() {
      setLoading(true)
      const dbRef = ref(db)
      try {
        const snapshot = await get(child(dbRef, 'users'))
        if (!snapshot.exists()) return

        const users = snapshot.val()
        const allArts = []
        let found = null

        Object.values(users).forEach((user) => {
          if (!user?.art) return
          Object.values(user.art).forEach((a) => {
            if (!a?.hide) allArts.push(a)
            if (a?.car === artId) found = a
          })
        })

        if (found) {
          setArt(found)
          setArts(allArts)
        }
      } catch (err) {
        console.error(err)
      } finally {
        setLoading(false)
      }
    }

    fetchByCarId()
  }, [artId, history?.state?.art, history?.state?.arts])

  async function sendEmail() {
    const usuario = auth?.currentUser
    if (isEmailSended) return
    const email = ''
    axios
      .post('https://strdsasipe-payment-createpi.herokuapp.com/sendEmailArt', {
        email,
        art,
        usuario,
      })
      .then(() => {
        ''
      })
      .catch((err) => {
        console.error(err)
      })
      .finally(() => {
        isEmailSended = true
      })
  }

  if (loading) {
    return (
      <div className="bg-preto min-h-[calc(100vh_-_80px)] flex items-center justify-center">
        <span className="text-branco font-light">Carregando fazenda...</span>
      </div>
    )
  }

  return (
    <div className="bg-preto min-h-[calc(100vh_-_80px)] flex justify-between flex-col relative">
      <CircleLight position={' top-0 left-0'} />
      <CircleLight position={' top-0 right-0'} />
      <CircleLight position={' bottom-[30%] left-0'} />
      <CircleLight position={' bottom-[30%] right-0'} />

      <div className="relative flex-grow items-center flex flex-col z-20 w-full max-w-6xl mx-auto px-4 lg:px-8 gap-6">
        <ArtInfos {...{ art }} />

        <Documents art={art} />
        <BlockchainHash />
        <QRCodeBlock filename={art?.title || art?.name || 'qrcode'} />
        <div className="divider w-[80%] self-center my-0" />
        <ToastContact {...{ sendEmail, setIsToastOpen }} />

        <ToastEmail {...{ isEmailSended, isToastOpen }} />
        <div className="w-full flex flex-col justify-center items-center border border-cinzaescuro rounded-lg">
          <StatsProfile art={art} />
        </div>

        <RelatedArts {...{ art, mQuery, arts }} />
      </div>
      <Footer />
    </div>
  )
}
